import { ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnExpander } from "components/common/TableColumns"
import { ColumnJumpDistance } from "components/sports/sjp/events/individual/startFinal/Columns"
import { ColumnBibTeam } from "../../common/TableColumns"


export function TableColumnsTrial() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsTrialSM() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsQual() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsQualSM() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}
